import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  input {
    background-color: #fff !important;
    color: #000;
  }

  .input {
    width: 300px;

    @media (max-width: 768px) {
      .ant-input-wrapper {
        width: 250px;
      }
    }
  }
`;

export const ViewInput = styled.div`
  min-height: 40px;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 5px;
  justify-content: space-between;
  text-align: center;
  font-family: "Montserrat-Regular";

  p {
    width: 100%;
    font-size: 12px;
    text-align: left;
    margin: 0 0 2px 5px;
    color: #000;
    font-family: "Montserrat-Medium";
  }

  input {
    background-color: transparent !important;
    color: #000;
  }
`;

export const Redes = styled.button`
  height: 45px;
  width: 45px;
  cursor: pointer;
  padding: 0;
  background-color: transparent;
  align-items: center;
  justify-content: center;
  border-radius: 45px;
  border: none;
  margin: 7px;
`;

export const RedesImage = styled.img`
  height: 45px;
  width: 45px;
  border-radius: 45px;
`;

export const Photo = styled.img`
  height: 120px;
  width: 120px;
  border-radius: 120px;
  margin-bottom: 12px;
`;

export const Name = styled.p`
  font-size: 18px;
  text-align: center;
  width: 100%;
  font-family: "Montserrat-SemiBold";
  margin: 5px 0;
  color: ${(props) => (props.dark ? "#fff" : "#141414")};
`;

export const Address = styled.p`
  font-size: 12px;
  text-align: center;
  width: 100%;
  font-family: "Montserrat-Medium";
  width: 80%;
  margin: 5px 0;
  color: ${(props) => (props.dark ? "#fff" : "#141414")};
`;

export const Description = styled.p`
  font-size: 15px;
  text-align: center;
  width: 100%;
  font-family: "Montserrat-Regular";
  width: 80%;
  color: ${(props) => (props.dark ? "#fff" : "#141414")};
`;

export const Select = styled.div`
  padding: 4px 12px;
  border-radius: 50px;
  background-color: ${(props) => (props.select ? "#20d071" : "#f0f0f0")};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  text-transform: uppercase;
`;

export const SearchContainer = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 1;
  display: flex;
  flex-direction: row;
  width: calc(100% - 30px);

  .ant-input-wrapper {
    width: 100%;
    max-width: 300px;
    margin-right: 15px;
  }
  button {
    font-size: 15px;
    font-family: "Montserrat-Medium";
  }
  @media (max-width: 400px) {
    width: 20px;
    span {
      display: none;
    }
  }
  @media (max-width: 768px) {
    .ant-input-wrapper {
      max-width: none; /* Remove the max-width on smaller screens */
    }
  }
`;

export const WarningTag = styled.div`
  background-color: #ffc107dd; /* Yellow background */
  color: #000; /* Black text */
  padding: 10px 20px;
  border-radius: 50px;
  font-size: 14px;
  font-family: "Montserrat-Medium";
  width: 90%;
  text-align: center;
  max-width: 300px;
  margin-top: 15px;
`;

export const TotalPartners = styled.p`
  background-color: #fffd; /* Yellow background */
  color: #000; /* Black text */
  padding: 8px 16px;
  border-radius: 50px;
  font-size: 14px;
  font-family: "Montserrat-Medium";
  width: 90%;
  text-align: center;
  max-width: 300px;
  margin-top: 15px;
`;

export const Load = styled.div`
  background-color: #fffc;
  padding: 20px;
  border-radius: 50px;
  position: absolute;
  right: 18px;
  bottom: 25px;
  z-index: 1;
`;
